import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AddOnListIndex from "../../../../components/SidetabPages/Catalog/Addon/AddOnListIndex";

const AddOn = () => {
  return (
    <>
      <AnnouncementBar />
      <AddOnListIndex />
    </>
  );
};
export default AddOn;
